import xor from 'lodash/xor';
import isEmpty from 'lodash/isEmpty';

import {DOMAIN_LOGIN_OPTIONS} from '../enums';

export const isSsoOnlyAllowedDomainLoginOption = loginOptions => isEmpty(xor(loginOptions, [DOMAIN_LOGIN_OPTIONS.SSO]));
